import { request, requestBlob } from "../../../app/api-client/ApiClient";

/**
 * Metodo para obtener las maquinas asocuadas a un admin
 * @param {Integer} idAdmin 
 */
export function getUsersAlcoholimetriaReporte(dispatch,id, dateInit,dateEnd, page, size) {

	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/alcoholimetro/historico/evbi/${id}?datestart=${dateInit}&dateend=${dateEnd}&page=${page}&size=${size}`,
		method: "GET",
	}, dispatch);
}
export function getAlcGrafic(dispatch,id, dateInit,dateEnd) {

	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/data/evbi/grafic/alcoholimetro/${id}/${dateInit}/${dateEnd}`,
		method: "GET",
	}, dispatch);
}



////////////// informacion
export function getPorcentageByidBascula(dispatch, id, dateInit, dateEnd) {

	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/data/evbi/meditions/${id}/${dateInit}/${dateEnd}`,
		method: "GET",
	}, dispatch);
}
export function getInfoBascula(dispatch, id, dateInit, dateEnd) {

	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/data/evbi/grafic/generic/${id}/${dateInit}/${dateEnd}`,
		method: "GET",
	}, dispatch);
}

/**
 * Obtiene el histórico de encuestas por estación(es) EVBI
 * Retorna métricas y listado de usuarios con mediciones
 * @param {function} dispatch - Dispatch de Redux
 * @param {string|number} id - ID de estación(es) EVBI. Puede ser un ID único o múltiples IDs concatenados con "-" (ej: "57-5655-52-48-64")
 * @param {string} datestart - Fecha inicio formato YYYY-MM-DD
 * @param {string} dateend - Fecha fin formato YYYY-MM-DD
 * @param {number} page - Número de página (default 0)
 * @param {number} size - Tamaño de página (default 30)
 * @param {string} filterEmpresa - Filtro de empresa (opcional)
 * @param {string} filterArea - Filtro de área (opcional)
 * @param {string} filterCargo - Filtro de cargo (opcional)
 * @returns {Promise} { pagina: { content[], page, size, totalElements, totalPages, last }, metricas: [] }
 * 
 * @example
 * // Consulta con una estación
 * getHistoricoEncuesta(dispatch, 57, "2026-02-01", "2026-02-28", 0, 400)
 * 
 * @example
 * // Consulta con múltiples estaciones
 * getHistoricoEncuesta(dispatch, "57-5655-52-48-64", "2026-02-01", "2026-02-28", 0, 400)
 */
export function getHistoricoEncuesta(dispatch, id, datestart, dateend, page, size, filterEmpresa = '', filterArea = '', filterCargo = '') {
	let url = `${process.env.REACT_APP_API_EVBI}/v1/alcoholimetro/historico/encuesta/evbi/${id}?datestart=${datestart}&dateend=${dateend}&page=${page}&size=${size}`;
	
	if (filterEmpresa) {
		url += `&filterEmpresa=${encodeURIComponent(filterEmpresa)}`;
	}
	if (filterArea) {
		url += `&filterArea=${encodeURIComponent(filterArea)}`;
	}
	if (filterCargo) {
		url += `&filterCargo=${encodeURIComponent(filterCargo)}`;
	}
	
	return request({
		url: url,
		method: "GET",
	}, dispatch);
}

/**
 * Exporta el histórico de encuestas como archivo Excel (.xls)
 * @param {function} dispatch - Dispatch de Redux
 * @param {string|number} evbiId - ID de estación(es) EVBI. Puede ser un ID único o múltiples IDs concatenados con "-" (ej: "57-5655-52-48-64")
 * @param {string} initDate - Fecha inicio formato YYYY-MM-DD
 * @param {string} lastDate - Fecha fin formato YYYY-MM-DD
 * @param {string} filterEmpresa - Filtro de empresa (opcional)
 * @param {string} filterArea - Filtro de área (opcional)
 * @param {string} filterCargo - Filtro de cargo (opcional)
 * @returns {Promise<Blob>} Archivo Excel como blob
 * 
 * @example
 * // Exportar con una estación
 * exportHistoricoEncuesta(dispatch, 57, "2026-02-01", "2026-02-28")
 * 
 * @example
 * // Exportar con múltiples estaciones
 * exportHistoricoEncuesta(dispatch, "57-5655-52-48-64", "2026-02-01", "2026-02-28")
 */
export function exportHistoricoEncuesta(dispatch, evbiId, initDate, lastDate, filterEmpresa = '', filterArea = '', filterCargo = '') {
	let url = `${process.env.REACT_APP_API_EVBI}/v1/alcoholimetro/export/historic/encuesta/evbi/dates/${evbiId}/${initDate}/${lastDate}?`;
	if (filterEmpresa) {
		url += `&filterEmpresa=${encodeURIComponent(filterEmpresa)}`;
	}
	if (filterArea) {
		url += `&filterArea=${encodeURIComponent(filterArea)}`;
	}
	if (filterCargo) {
		url += `&filterCargo=${encodeURIComponent(filterCargo)}`;
	}
	

	return requestBlob({
		url: url,
		method: "GET",
	}, dispatch);
}
